import { html } from 'fxjs/es';
import { UtilImageS } from '../../../../../../Util/Image/S/Function/module/UtilImageS.js';
import { MShopCoreTmplS } from '../../../../../Core/S/Tmpl/module/MShopCoreTmplS.js';
import { MShopAppStoreCommunityConstantS } from '../../../../Store/Community/S/Constant/module/MShopAppStoreCommunityConstantS.js';
import { UserConstantS } from '../../../../../../User/S/Constant/module/UserConstantS.js';
import { CloseIcon } from '../../../../../../../services/MarppleShop/renderApp/components/atoms/Icon/index.ts';
import { typo } from '../../../../../../../services/MarppleShop/shared/typography/typo.js';
import { htmlIf } from '../../../../../../Util/S/Function/util.js';
import { ButtonAction } from '../../../../../../../services/MarppleShop/shared/components/atoms/ButtonAction/ButtonAction.ts';
import { InputText } from '../../../../../../../services/MarppleShop/renderApp/components/atoms/Input/InputText.ts';
import { ButtonRadio } from '../../../../../../../services/MarppleShop/renderApp/components/atoms/ButtonRadio/ButtonRadio.ts';

export const account = ({ user = {}, is_inhouse, brand_color, menu_color, is_mobile }) => {
  if (is_inhouse) {
    return html`
      <div class="my-account">
        <h1 class="my-account__title">${T('mypage::계정 설정')}</h1>
        <div class="my-account__controls">
          <div class="my-account__control">
            ${is_mobile
              ? ''
              : html`<div class="my-account__control_head">${ET('my_page::my_account_01')}</div>`}
            <div class="my-account__control_body">
              <div class="my-account__profile_image">
                <label class="my-account__profile_image__preview">
                  <input type="file" name="file" accept="image/jpeg,image/png,image/pjpeg" />
                  <img
                    src="${UtilImageS.getResizedUrl({
                      url: user.profile_image || MShopAppStoreCommunityConstantS.EMPTY_USER_IMG,
                      quality: 100,
                      width: 192,
                      format: 'webp',
                    })}"
                    alt="profile image"
                  />
                  <div class="my-account__profile_image__edit">${MShopCoreTmplS.editPenIcon()}</div>
                </label>
                <div class="my-account__profile_image__notice">
                  <div>${ET('my_page::my_account_02')}</div>
                  <button
                    class="my-account__profile_image__delete"
                    type="button"
                    data-active="${!!user.profile_image}"
                  >
                    ${ET('my_page::my_account_06')}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="my-account__control">
            <div class="my-account__control_head">${T('my_info::이메일 주소 (ID)')}</div>
            <div class="my-account__control_body">
              <input type="text" name="email" value="${user?.email || ''}" disabled />
            </div>
          </div>
        </div>
        <div class="my-account__buttons">
          <button
            ${brand_color
              ? `style="background-color: ${brand_color}; ${menu_color ? `color: ${menu_color};` : ''}"`
              : ''}
            type="button"
            class="my-account__btn_profile_modify"
          >
            ${T('my_info::Modify')}
          </button>
        </div>
      </div>
    `;
  }

  return html`
    <div class="my-account">
      <div class="my-account__controls">
        <div class="my-account__control">
          <div class="my-account__control_body">
            <div class="my-account__profile_image">
              <div class="my-account__profile_image__preview">
                <img
                  src="${UtilImageS.getResizedUrl({
                    url: user.profile_image || MShopAppStoreCommunityConstantS.EMPTY_USER_IMG,
                    quality: 80,
                    width: 300,
                    format: 'webp',
                  })}"
                  alt="profile image"
                />
                <button
                  class="my-account__profile_image__delete"
                  type="button"
                  data-active="${!!user.profile_image}"
                >
                  <span class="my-account__profile_image__icon"> ${CloseIcon({ htmlFn: html })} </span>
                </button>
                <label class="my-account__profile_image__upload">
                  <input type="file" name="file" accept="image/jpeg,image/png,image/pjpeg" />
                  <span class="my-account__profile_image__upload-text"
                    >${ET(user.profile_image ? 'my_page::my_account_07' : 'my_page::my_account_08')}</span
                  >
                </label>
              </div>

              <div class="my-account__profile_image__notice ${typo('14_medium')}">
                ${ET('my_page::my_account_02')}
              </div>
            </div>
          </div>
        </div>
        <div class="my-account__control">
          <div class="my-account__control_head ${typo('16_bold')}">
            <span class="required">${T('my_info::이메일 주소 (ID)')}</span>
          </div>
          <div class="my-account__control_body">
            <div class="my-account__control-email">
              ${new InputText({
                is_mobile,
                name: 'email',
                readonly: true,
                value: user?.email || '',
              }).toHtmlSSR()}
              ${htmlIf(
                user.group_type !== UserConstantS.GROUP_TYPE.SOOP,
                new ButtonAction({
                  size: is_mobile ? 'regular' : 'medium',
                  klass: 'my-account__btn_change_email',
                  label: T('my_info::이메일 변경'),
                }).toHtmlSSR(),
              )}
            </div>

            <p class="my-account__help_txt1 ${typo('12_medium')}">
              ${T('my_info::ⓘ 위 이메일로 주문 내역 메일이 전송됩니다.')}
            </p>
          </div>
        </div>
        <div class="my-account__control">
          <div class="my-account__control_head ${typo('16_bold')}">
            <span class="required">${T('my_info::Name')}</span>
          </div>
          <div class="my-account__control_body">
            ${new InputText({
              is_mobile,
              name: 'name',
              value: user?.name || '',
              placeholder: ET('mps2::mypage::이름을 입력해 주세요'),
              custom_klass: 'my-account__change-name-input',
            }).toHtmlSSR()}
          </div>
        </div>
        ${user.group_type === UserConstantS.GROUP_TYPE.SOOP
          ? ''
          : html`<div class="my-account__control">
              <div class="my-account__control_head ${typo('16_bold')}">${T('my_info::Password')}</div>
              <div class="my-account__control_body">
                ${new ButtonAction({
                  size: 'medium',
                  klass: 'my-account__btn_change_pw',
                  label: T('login::Reset password'),
                  type: 'white',
                }).toHtml()}
              </div>
            </div>`}
        <div class="my-account__control">
          <label>
            <div class="my-account__control_head ${typo('16_bold')}">${T('my_info::BirthDay')}</div>
            <div class="my-account__control_body">
              ${new InputText({
                is_mobile,
                name: 'birthday',
                value: user?.birthday ? moment(user?.birthday).format('YYYYMMDD') : '',
                comma_seperated: false,
                inputmode: 'numeric',
                placeholder: '19920216',
                maxlength: 8,
                custom_klass: 'my-account__change-birthday-input',
              }).toHtmlSSR()}
            </div>
          </label>
        </div>
        ${T.lang == 'kr'
          ? html`
              <div class="my-account__control">
                <label>
                  <div class="my-account__control_head ${typo('16_bold')}">${T('my_info::Phone')}</div>
                  <div class="my-account__control_body">
                    ${new InputText({
                      is_mobile,
                      name: 'mobile',
                      value: user?.mobile || '',
                      comma_seperated: false,
                      inputmode: 'numeric',
                      placeholder: '하이픈(-) 없이 숫자만 입력해 주세요.',
                      maxlength: 12,
                      custom_klass: 'my-account__change-phone-input',
                    }).toHtmlSSR()}
                  </div>
                </label>
              </div>
            `
          : ''}
        <div class="my-account__control my-account__gender">
          <div class="my-account__control_head ${typo('16_bold')}">${T('my_info::Gender')}</div>
          <div class="my-account__control_body my-account__control-radio">
            ${new ButtonRadio({
              active: user?.gender == 'MALE',
              label: T('my_info::MALE'),
              name: 'gender',
              value: 'MALE',
              wrapper_klass: 'my-account__radio-item',
            }).toHtml()}
            ${new ButtonRadio({
              active: user?.gender == 'FEMALE',
              label: T('my_info::FEMALE'),
              name: 'gender',
              value: 'FEMALE',
              wrapper_klass: 'my-account__radio-item',
            }).toHtml()}
          </div>
        </div>
        <div class="my-account__control my-account__agree">
          <div class="my-account__control_head ${typo('16_bold')}">${ET('my_page::agree_email')}</div>
          <div class="my-account__control_body my-account__control-radio">
            ${new ButtonRadio({
              active: user?.agree_email,
              label: ET('mps2::common::agree'),
              name: 'agree_email',
              value: 'true',
              wrapper_klass: 'my-account__radio-item',
            }).toHtml()}
            ${new ButtonRadio({
              active: !user?.agree_email,
              label: ET('mps2::common::disagree'),
              name: 'agree_email',
              value: 'false',
              wrapper_klass: 'my-account__radio-item',
            }).toHtml()}
          </div>
        </div>
      </div>
      <div class="my-account__buttons">
        ${new ButtonAction({
          type: user.email && user.name ? 'white' : 'disabled',
          label: T('my_info::Modify'),
          size: 'large',
          klass: 'my-account__btn_modify',
        }).toHtmlSSR()}
      </div>
    </div>
  `;
};

export const nessAccount = ({ user = {}, is_mobile }) => {
  const texts = {
    nick_name: ET('my_page::nick_name'),
    notice_profile_image: ET('my_page::my_account_02'),
    save: ET('my_page::save'),
    nexon_account_info: ET('ness::mypage::nexon_account_info'),
    nexon_account_modify: ET('ness::mypage::nexon_account_modify'),
    nexon_account_modify_mo: ET('ness::mypage::nexon_account_modify_mo'),
    email: ET('my_page::email'),
    no_email: ET('my_page::no_email'),
    mobile: ET('my_page::mobile'),
    agree_email: ET('my_page::agree_email'),
    view_agree_email: ET('my_page::view_agree_email'),
    is_hidden_user: ET('ness::my_page::is_hidden_user'),
    nexon_agree_info: ET('ness::mypage::nexon_agree_info'),
  };

  return html`
    <div class="my-account">
      <div class="my-account__controls">
        <div class="my-account__control">
          <div class="my-account__control_body">
            <div class="my-account__profile_image">
              <label class="my-account__profile_image__preview">
                <input type="file" name="file" accept="image/jpeg,image/png,image/pjpeg" />
                <img
                  class="lazy-src img"
                  src="${UtilImageS.getResizedUrl({
                    url: user.profile_image || MShopAppStoreCommunityConstantS.EMPTY_NESS_USER_IMG,
                    quality: 100,
                    width: 400,
                    format: 'webp',
                  })}"
                  alt="profile image"
                />
                <div class="my-account__profile_image__edit">Edit</div>
                <button
                  class="my-account__profile_image__delete"
                  type="button"
                  data-active="${!!user.profile_image}"
                ></button>
              </label>
              <div class="my-account__profile_image__notice">
                <div>${texts.notice_profile_image}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="my-account__control nexon-info">
          <div class="my-account__nexon-title-wrap">
            <div class="my-account__nexon-title">${texts.nexon_account_info}</div>
            <div class="my-account__buttons">
              <button type="button" class="my-account__btn_modify--nexon">
                ${is_mobile ? texts.nexon_account_modify_mo : texts.nexon_account_modify}
              </button>
            </div>
          </div>
          <div class="my-account__control-wrap nexon">
            <div class="my-account__control_head nexon">${texts.email}</div>
            <div class="my-account__control_body">
              <input type="text" name="email" value="${user?.email || texts.no_email}" disabled />
            </div>
          </div>
          <div class="my-account__control-wrap nexon my-account--mt24">
            <div class="my-account__control_head nexon">${texts.nick_name}</div>
            <div class="my-account__control_body">
              <input type="text" name="nick_name" value="${user?.nick_name || ''}" disabled />
            </div>
          </div>
        </div>
      </div>
    </div>
  `;
};

// const sms_email = (user) => html`
//   <div class="my-account__control" style="display: none;">
//     <div class="my-account__control_head">${T('my_info::SMS News')}</div>
//     <div class="my-account__control_body">
//       <label>
//         <input type="radio" name="agree_sms" value="true" ${user.agree_sms ? ' checked' : ''} />
//         <span>${T('my_info::YES')}</span>
//       </label>
//       <label>
//         <input type="radio" name="agree_sms" value="false" ${!user.agree_sms ? ' checked' : ''} />
//         <span>${T('my_info::NO')}</span>
//       </label>
//     </div>
//   </div>
//   <div class="my-account__control" style="display: none;">
//     <div class="my-account__control_head">${T('my_info::Email News')}</div>
//     <div class="my-account__control_body">
//       <label>
//         <input type="radio" name="agree_email" value="true" ${user.agree_email ? ' checked' : ''} />
//         <span>${T('my_info::YES')}</span>
//       </label>
//       <label>
//         <input type="radio" name="agree_email" value="false" ${!user.agree_email ? ' checked' : ''} />
//         <span>${T('my_info::NO')}</span>
//       </label>
//     </div>
//   </div>
// `;
